import React from "react";
import { Modal, Button } from "react-bootstrap";
// import "./SanjivanSuvidha.css";
import "../../Pages/MemberDashboard/SanjivanSuvidha.css";
const CustomModal = ({
  show2,
  handleClose2,
  handleYesFunctionality,
  title,
  body,
  buttonLabel1,
  buttonLabel2,
  onHide2,
  hideButton2 = false,
  hideButton1 = false,
}) => {
  return (
    <Modal
      show={show2}
      onHide={handleClose2}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="custom-modal-header">
        <Modal.Title dangerouslySetInnerHTML={{ __html: title }} />
      </Modal.Header>
      <Modal.Body dangerouslySetInnerHTML={{ __html: body }} />
      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center">
          <div className="">
            {!hideButton1 && (
              <button
                className="text-center btn-submit mr-3"
                onClick={handleYesFunctionality}
              >
                {buttonLabel1}
              </button>
            )}
          </div>
          <div>
            {!hideButton2 && (
              <button className="btn-save text-center" onClick={handleClose2}>
                {buttonLabel2}
              </button>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CustomModal;
